import { render } from "./edit-product.vue?vue&type=template&id=6c0b2bac&scoped=true"
import script from "./edit-product.vue?vue&type=script&lang=js"
export * from "./edit-product.vue?vue&type=script&lang=js"

import "./edit-product.vue?vue&type=style&index=0&id=6c0b2bac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0b2bac"]])

export default __exports__